import React, { useState } from "react";
import { toggle } from "../../../util/common";
import { WalletItemFamilyMember } from "../../../store/common";
import { DialogComponent } from "../../common/DialogComponent";
import ConfirmDeleteWalletDialog from "../../Dialogs/lostWallet/ConfirmDeleteWalletDialog";
import FamilyAssetDialog from "../../Dialogs/lostWallet/FamilyAssetDialog";
import { useTranslation } from "react-i18next";

const FamilyAsset: React.FunctionComponent<{ requestDataCallback(): void; walletItemFamilyMembers: WalletItemFamilyMember[] }> = (props) => {
    const [deleteWalletDialogIsVisible, setDeleteWalletDialogIsVisible] = useState(false);
    const [isFamilyAssetDialogVisible, setFamilyAssetDialogIsVisible] = useState(false);
    const [selectedItem, setSelectedItem] = useState({});
    const { t: tLang, i18n: i18nLang } = useTranslation();

    const showDeleteWalletDialog = (selectedItem: any): any => {
        setSelectedItem(selectedItem);
        setDeleteWalletDialogIsVisible(true);
    };

    const closeDeleteWalletDialog = (): any => {
        setDeleteWalletDialogIsVisible(false);
    };

    const openFamilyAssetDialog = (selectedItem: any): any => {
        setSelectedItem(selectedItem);
        setFamilyAssetDialogIsVisible(true);
    };

    const closeFamilyAssetDialog = (): any => {
        setFamilyAssetDialogIsVisible(false);
    };

    const getTtemTitle = (asset: WalletItemFamilyMember) => {
        let title = "";
        if (asset.firstName) {
            title = title + asset.firstName + " ";
        }
        if (asset.lastName) {
            title = title + asset.lastName;
        }
        return title;
    };

    const getRelationship = (key: string) => {
        const relationshipMap = new Map([
            ["CHILD_BOY", "Child - Boy(under 21 living in your household)"],
            ["CHILD_GIRL", "Child - Girl (under 21 living in your household)"],
            ["DOMESTIC_PARTNER", "Domestic Partner (recognized by your state of residence)"],
            ["HUSBAND", "Husband"],
            ["WIFE", "Wife"],
            ["YOUNG_ADULT", "Young Adult(under 25 and in school)"],
        ]);
        const relationship = relationshipMap.has(key) ? relationshipMap.get(key) : "";
        return relationship;
    };

    return (
        <React.Fragment>
            {props.walletItemFamilyMembers &&
                props.walletItemFamilyMembers.map((asset: WalletItemFamilyMember, index: number) => (
                    <div className="data-row" key={"family-asset-" + index}>
                        <div className="link-item">
                            <button
                                type="button"
                                aria-expanded="false"
                                className="link-button"
                                id={"btn-family-asset-" + index}
                                onClick={() => toggle(`family-asset-${index}-details`, `btn-family-asset-${index}`)}
                            >
                                <span className="row link-item">
                                    <span className="col-xs col-no-gutter link-text">
                                        <span className="link-title">
                                            <span className="btn-toggle-status sr-only">Show</span>
                                            {getTtemTitle(asset)}
                                        </span>
                                        <span className="link-helper">
                                            <span className="sr-only">Item Type: </span>{tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.title")}
                                        </span>
                                    </span>
                                </span>
                            </button>

                            <div className="wallet-details" id={"family-asset-" + index + "-details"} style={{ display: "none" }}>
                                <div
                                    role="grid"
                                    className="data-grid row-height-xs"
                                    id={"family-asset-" + index + "-title"}
                                    aria-labelledby={"family-asset-" + index + "-title"}
                                >
                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={"family-asset-" + index + "-first-name"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.label.fname")}
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-11 col-sm-7 col-no-gutter" aria-labelledby={"family-asset-" + index + "-first-name"}>
                                            <div className="data-value">
                                                {asset.firstName ? asset.firstName : ""}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={"family-asset-" + index + "-middle-initial"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.label.mName")}
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-11 col-sm-7 col-no-gutter" aria-labelledby={"family-asset-" + index + "-last-name"}>
                                            <div className="data-value">
                                                {asset.middleName ? asset.middleName : ""}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={"family-asset-" + index + "-last-name"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.label.lName")}
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-11 col-sm-7 col-no-gutter" aria-labelledby={"family-asset-" + index + "-last-name"}>
                                            <div className="data-value">
                                                {asset.lastName ? asset.lastName : ""}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={"family-asset-" + index + "-suffix"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.label.suffix")}
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-11 col-sm-7 col-no-gutter" aria-labelledby={"family-asset-" + index + "-suffix"}>
                                            <div className="data-value">
                                                {asset.generationSuffix ? asset.generationSuffix : ""}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={"family-asset-" + index + "-relationship"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.label.relationship")}
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-11 col-sm-7 col-no-gutter" aria-labelledby={"family-asset-" + index + "-relationship"}>
                                            <div className="data-value">
                                                {asset.relationship ? getRelationship(asset.relationship) : ""}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={"family-asset-" + index + "-date-of-birth"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.label.dob")}
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-11 col-sm-7 col-no-gutter" aria-labelledby={"family-asset-" + index + "-date-of-birth"}>
                                            <div className="data-value">
                                                {asset.dob ? asset.dob : ""}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={"family-asset-" + index + "-ssn"}>
                                                SSN
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-11 col-sm-7 col-no-gutter" aria-labelledby={"family-asset-" + index + "-ssn"}>
                                            <div className="data-value">
                                                {asset.ssn ? asset.ssn : ""}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={"family-asset-" + index + "-driver-license"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.label.licenseNumber")}
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-11 col-sm-7 col-no-gutter" aria-labelledby={"family-asset-" + index + "-driver-license"}>
                                            <div className="data-value">
                                                {asset.driverLicenseNumber ? asset.driverLicenseNumber : ""}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={"family-asset-" + index + "-email"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.label.email")}
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-11 col-sm-7 col-no-gutter" aria-labelledby={"family-asset-" + index + "-email"}>
                                            <div className="data-value">
                                                {asset.email ? asset.email : ""}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={"family-asset-" + index + "-notes"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.label.notes")}
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-11 col-sm-7 col-no-gutter" aria-labelledby={"family-asset-" + index + "-notes"}>
                                            <div className="data-value">
                                                {asset.notes ? asset.notes : ""}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row between-xs margin-top-l">
                                    <div className="col-xs flex-grow-null col-no-gutter"></div>
                                    <div className="col-xs flex-grow-null col-no-gutter">
                                        <ul className="list-reset list-inline">
                                            <li>
                                                <button
                                                    type="button"
                                                    className="btn-default btn-red-outline btn-no-border"
                                                    onClick={() => showDeleteWalletDialog(asset)}
                                                >
                                                    <span className="btn-icon">
                                                        <em className="las la-trash-alt"></em>
                                                    </span>
                                                    <span className="btn-text">{tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.deleteButtonText")} </span>
                                                </button>
                                            </li>
                                            <li className="margin-left-xs">
                                                <button
                                                    type="button"
                                                    className="btn-default btn-primary-outline"
                                                    id="edit-credit-card-1"
                                                    onClick={() => openFamilyAssetDialog(asset)}
                                                >
                                                    <span className="btn-icon">
                                                        <em className="las la-edit-alt"></em>
                                                    </span>
                                                    <span className="btn-text">{tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.editDetailsButtonText")}</span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}

            {/* Delete modal*/}
            {deleteWalletDialogIsVisible && (
                <DialogComponent dialogId="dialog-delete-bank-account-wallet" title="Delete Wallet" closeDialog={closeDeleteWalletDialog}>
                    <ConfirmDeleteWalletDialog
                        requestDataCallback={props.requestDataCallback}
                        closeDialog={closeDeleteWalletDialog}
                        walletItem={selectedItem}
                        itemType="family-member"
                    />
                </DialogComponent>
            )}

            {/* Edit modal*/}
            {isFamilyAssetDialogVisible && (
                <DialogComponent dialogId="dialog-edit-family-account-dialog" title="Edit Family Asset" closeDialog={closeFamilyAssetDialog}>
                    <FamilyAssetDialog requestDataCallback={props.requestDataCallback} closeDialog={closeFamilyAssetDialog} familyAsset={selectedItem} />
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default FamilyAsset;
